import { axiosInstance } from "../authService";
import ApiUrlConstant from "../Constants";
const headers = { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_API_KEY }

const TemplateService = {
    getTemplates: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.getTemplates(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    createTemplate: (data, token) => {
        return axiosInstance.post(ApiUrlConstant.createTemplate(), data, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    deleteTemplate: (params = {}, token) => {
        return axiosInstance.delete(ApiUrlConstant.deleteTemplate(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },

    getdefaultTemplate: (token) => {
        return axiosInstance.get(ApiUrlConstant.getdefaultTemplate(), {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    getTemplate: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.getTemplate(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    updateTemplate: (id, payload, token) => {
        return axiosInstance.put(ApiUrlConstant.updateTemplate(id), payload, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    getAllTemplate: (token) => {
        return axiosInstance.get(ApiUrlConstant.getAllTemplate(), {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    cloneTemplate: (data, token) => {
        return axiosInstance.post(ApiUrlConstant.cloneTemplate(), data, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    archiveTemplate: (params = {}, token) => {
        return axiosInstance.delete(ApiUrlConstant.archiveTemplate(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },

    saveResponse: (data, token) => {
        return axiosInstance.post(ApiUrlConstant.saveResponse(), data, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    getTemplateLogs: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.getTemplateLogs(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    getTemplateLogsById: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.getTemplateLogsById(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    getTemplateResponse: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.getTemplateResponse(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    // Item 8 (UAT B6): exchange stored photo urls for short-lived signed read
    // links. The blob container is private; these are minted at read time and
    // must never be written back into form data.
    getPhotoAccessUrls: (data, token) => {
        return axiosInstance.post(ApiUrlConstant.getPhotoAccessUrls(), data, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },

}

export default TemplateService